export default [
  { dial_code: '+93', iso: 'AF' },
  { dial_code: '+355', iso: 'AL' },
  { dial_code: '+213', iso: 'DZ' },
  { dial_code: '+376', iso: 'AD' },
  { dial_code: '+244', iso: 'AO' },
  { dial_code: '+54', iso: 'AR' },
  { dial_code: '+374', iso: 'AM' },
  { dial_code: '+297', iso: 'AW' },
  { dial_code: '+61', iso: 'AU' },
  { dial_code: '+43', iso: 'AT' },
  { dial_code: '+994', iso: 'AZ' },
  { dial_code: '+973', iso: 'BH' },
  { dial_code: '+880', iso: 'BD' },
  { dial_code: '+375', iso: 'BY' },
  { dial_code: '+32', iso: 'BE' },
  { dial_code: '+501', iso: 'BZ' },
  { dial_code: '+229', iso: 'BJ' },
  { dial_code: '+975', iso: 'BT' },
  { dial_code: '+591', iso: 'BO' },
  { dial_code: '+387', iso: 'BA' },
  { dial_code: '+267', iso: 'BW' },
  { dial_code: '+55', iso: 'BR' },
  { dial_code: '+673', iso: 'BN' },
  { dial_code: '+359', iso: 'BG' },
  { dial_code: '+226', iso: 'BF' },
  { dial_code: '+257', iso: 'BI' },
  { dial_code: '+855', iso: 'KH' },
  { dial_code: '+237', iso: 'CM' },
  { dial_code: '+238', iso: 'CV' },
  { dial_code: '+236', iso: 'CF' },
  { dial_code: '+235', iso: 'TD' },
  { dial_code: '+56', iso: 'CL' },
  { dial_code: '+86', iso: 'CN' },
  { dial_code: '+57', iso: 'CO' },
  { dial_code: '+269', iso: 'KM' },
  { dial_code: '+506', iso: 'CR' },
  { dial_code: '+385', iso: 'HR' },
  { dial_code: '+53', iso: 'CU' },
  { dial_code: '+357', iso: 'CY' },
  { dial_code: '+420', iso: 'CZ' },
  { dial_code: '+243', iso: 'CD' },
  { dial_code: '+45', iso: 'DK' },
  { dial_code: '+253', iso: 'DJ' },
  { dial_code: '+593', iso: 'EC' },
  { dial_code: '+20', iso: 'EG' },
  { dial_code: '+503', iso: 'SV' },
  { dial_code: '+240', iso: 'GQ' },
  { dial_code: '+291', iso: 'ER' },
  { dial_code: '+372', iso: 'EE' },
  { dial_code: '+268', iso: 'SZ' },
  { dial_code: '+251', iso: 'ET' },
  { dial_code: '+679', iso: 'FJ' },
  { dial_code: '+358', iso: 'FI' },
  { dial_code: '+33', iso: 'FR' },
  { dial_code: '+241', iso: 'GA' },
  { dial_code: '+220', iso: 'GM' },
  { dial_code: '+995', iso: 'GE' },
  { dial_code: '+49', iso: 'DE' },
  { dial_code: '+233', iso: 'GH' },
  { dial_code: '+30', iso: 'GR' },
  { dial_code: '+502', iso: 'GT' },
  { dial_code: '+224', iso: 'GN' },
  { dial_code: '+245', iso: 'GW' },
  { dial_code: '+592', iso: 'GY' },
  { dial_code: '+509', iso: 'HT' },
  { dial_code: '+504', iso: 'HN' },
  { dial_code: '+36', iso: 'HU' },
  { dial_code: '+354', iso: 'IS' },
  { dial_code: '+91', iso: 'IN' },
  { dial_code: '+62', iso: 'ID' },
  { dial_code: '+98', iso: 'IR' },
  { dial_code: '+964', iso: 'IQ' },
  { dial_code: '+353', iso: 'IE' },
  { dial_code: '+972', iso: 'IL' },
  { dial_code: '+39', iso: 'IT' },
  { dial_code: '+81', iso: 'JP' },
  { dial_code: '+962', iso: 'JO' },
  { dial_code: '+7', iso: 'KZ' },
  { dial_code: '+254', iso: 'KE' },
  { dial_code: '+686', iso: 'KI' },
  { dial_code: '+965', iso: 'KW' },
  { dial_code: '+996', iso: 'KG' },
  { dial_code: '+856', iso: 'LA' },
  { dial_code: '+371', iso: 'LV' },
  { dial_code: '+961', iso: 'LB' },
  { dial_code: '+266', iso: 'LS' },
  { dial_code: '+231', iso: 'LR' },
  { dial_code: '+218', iso: 'LY' },
  { dial_code: '+423', iso: 'LI' },
  { dial_code: '+370', iso: 'LT' },
  { dial_code: '+352', iso: 'LU' },
  { dial_code: '+261', iso: 'MG' },
  { dial_code: '+265', iso: 'MW' },
  { dial_code: '+60', iso: 'MY' },
  { dial_code: '+960', iso: 'MV' },
  { dial_code: '+223', iso: 'ML' },
  { dial_code: '+356', iso: 'MT' },
  { dial_code: '+692', iso: 'MH' },
  { dial_code: '+222', iso: 'MR' },
  { dial_code: '+230', iso: 'MU' },
  { dial_code: '+52', iso: 'MX' },
  { dial_code: '+373', iso: 'MD' },
  { dial_code: '+377', iso: 'MC' },
  { dial_code: '+976', iso: 'MN' },
  { dial_code: '+382', iso: 'ME' },
  { dial_code: '+212', iso: 'MA' },
  { dial_code: '+258', iso: 'MZ' },
  { dial_code: '+95', iso: 'MM' },
  { dial_code: '+264', iso: 'NA' },
  { dial_code: '+674', iso: 'NR' },
  { dial_code: '+977', iso: 'NP' },
  { dial_code: '+31', iso: 'NL' },
  { dial_code: '+64', iso: 'NZ' },
  { dial_code: '+505', iso: 'NI' },
  { dial_code: '+227', iso: 'NE' },
  { dial_code: '+234', iso: 'NG' },
  { dial_code: '+47', iso: 'NO' },
  { dial_code: '+968', iso: 'OM' },
  { dial_code: '+92', iso: 'PK' },
  { dial_code: '+680', iso: 'PW' },
  { dial_code: '+507', iso: 'PA' },
  { dial_code: '+675', iso: 'PG' },
  { dial_code: '+595', iso: 'PY' },
  { dial_code: '+51', iso: 'PE' },
  { dial_code: '+63', iso: 'PH' },
  { dial_code: '+48', iso: 'PL' },
  { dial_code: '+351', iso: 'PT' },
  { dial_code: '+974', iso: 'QA' },
  { dial_code: '+40', iso: 'RO' },
  { dial_code: '+7', iso: 'RU' },
  { dial_code: '+250', iso: 'RW' },
  { dial_code: '+685', iso: 'WS' },
  { dial_code: '+378', iso: 'SM' },
  { dial_code: '+239', iso: 'ST' },
  { dial_code: '+966', iso: 'SA' },
  { dial_code: '+221', iso: 'SN' },
  { dial_code: '+381', iso: 'RS' },
  { dial_code: '+248', iso: 'SC' },
  { dial_code: '+232', iso: 'SL' },
  { dial_code: '+65', iso: 'SG' },
  { dial_code: '+421', iso: 'SK' },
  { dial_code: '+386', iso: 'SI' },
  { dial_code: '+677', iso: 'SB' },
  { dial_code: '+252', iso: 'SO' },
  { dial_code: '+27', iso: 'ZA' },
  { dial_code: '+211', iso: 'SS' },
  { dial_code: '+34', iso: 'ES' },
  { dial_code: '+94', iso: 'LK' },
  { dial_code: '+249', iso: 'SD' },
  { dial_code: '+597', iso: 'SR' },
  { dial_code: '+46', iso: 'SE' },
  { dial_code: '+41', iso: 'CH' },
  { dial_code: '+963', iso: 'SY' },
  { dial_code: '+886', iso: 'TW' },
  { dial_code: '+992', iso: 'TJ' },
  { dial_code: '+255', iso: 'TZ' },
  { dial_code: '+66', iso: 'TH' },
  { dial_code: '+228', iso: 'TG' },
  { dial_code: '+676', iso: 'TO' },
  { dial_code: '+216', iso: 'TN' },
  { dial_code: '+90', iso: 'TR' },
  { dial_code: '+993', iso: 'TM' },
  { dial_code: '+688', iso: 'TV' },
  { dial_code: '+256', iso: 'UG' },
  { dial_code: '+380', iso: 'UA' },
  { dial_code: '+971', iso: 'AE' },
  { dial_code: '+44', iso: 'GB' },
  { dial_code: '+1', iso: 'US' },
  { dial_code: '+598', iso: 'UY' },
  { dial_code: '+998', iso: 'UZ' },
  { dial_code: '+678', iso: 'VU' },
  { dial_code: '+379', iso: 'VA' },
  { dial_code: '+58', iso: 'VE' },
  { dial_code: '+84', iso: 'VN' },
  { dial_code: '+967', iso: 'YE' },
  { dial_code: '+260', iso: 'ZM' },
  { dial_code: '+263', iso: 'ZW' },
];
